import { gql } from '@apollo/client'

const GET_ALL_CITY = gql`
  query Cities($filter: CityFilter, $first: Int, $offset: Int) {
    cities(filter: $filter, first: $first, offset: $offset, orderBy: NAME_ASC) {
      edges {
        node {
          id
          name
          postcode
        }
      }
    }
  }
`
export default GET_ALL_CITY
